import matreshkaError from '../../_helpers/matreshkaerror.js';
import forEach from '../../_helpers/foreach.js';
import checkAlreadyRendered from './checkalreadyrendered.js';
// whether a change made with these options renders: rendering is on and the array has a container
export function rendersChange(self, eventOptions) {
  var _self$renderIfPossibl = self.renderIfPossible,
    renderIfPossible = _self$renderIfPossibl === void 0 ? true : _self$renderIfPossibl;
  return !!(renderIfPossible && !(eventOptions != null && eventOptions.dontRender) && (self.nodes.container || self.nodes.sandbox));
}
// fill and copyWithin can't render: they throw before they change the array
export function checkCompatRenderer(self, method, eventOptions) {
  if (rendersChange(self, eventOptions)) {
    throw matreshkaError('array:method_compat_renderer', {
      method: method
    });
  }
}
// an adding method throws before it changes the array where rendering the added items would throw: an item
// rendered already, or one object twice; an item the same splice removes (`kept`) keeps its node, which moves
export default function checkAddedItems(self, selfDef, added, eventOptions, kept) {
  if (!rendersChange(self, eventOptions)) {
    return;
  }
  var rendering = new WeakMap();
  var itemRenderer = self.itemRenderer;
  forEach(added, function (item) {
    if (item && typeof item === 'object' && !(kept && kept.indexOf(item) !== -1)) {
      checkAlreadyRendered({
        item: item,
        selfDef: selfDef
      });
      // only an item with a renderer gets a node, so only its second place throws
      if (item.renderer || itemRenderer) {
        if (rendering.has(item)) {
          throw matreshkaError('array:add_render_twice');
        }
        rendering.set(item, true);
      }
    }
  });
}